import { useTitleBarNavigationStore } from "client/Features/Layout/TitleBar/titleBarNavigationStore";
import { shallowComparison } from "client/Misc/compareUtils";
import { useEffect } from "react";

export type TitleBarBackButtonProps = {
	onBack(): void;
};

export const TitleBarBackButton = (props: TitleBarBackButtonProps): null => {
	const {
		onBack
	} = props;

	const {
		setBackNavigationCallback,
		setIsBackButtonVisible,
		restoreState
	} = useTitleBarNavigationStore(
		(x) => ({
			setBackNavigationCallback: x.setBackNavigationCallback,
			setIsBackButtonVisible: x.setIsBackButtonAvailable,
			restoreState: x.restoreState
		}),
		shallowComparison
	);

	useEffect(
		(): () => void => {
			setIsBackButtonVisible(true);
			setBackNavigationCallback(onBack);

			return (): void => {
				restoreState();
			};
		},
		[
			onBack,
			setBackNavigationCallback,
			setIsBackButtonVisible,
			restoreState
		]
	);

	return null;
};
TitleBarBackButton.displayName = "TitleBarBackButton";